import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/WhyUs.css";

const features = [
  {
    id: 1,
    name: "Certified professionals",
    desc: "Board-certified dermatologists and trained clinicians.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e27a8b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  },
  {
    id: 2,
    name: "Advanced laser tech",
    desc: "FDA-cleared diode & fractional systems.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e27a8b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
  {
    id: 3,
    name: "Safe & hygienic",
    desc: "Sterile single-use protocols, every session.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e27a8b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
  {
    id: 4,
    name: "Affordable pricing",
    desc: "Transparent packages and bundle savings.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e27a8b" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
  },
];

const EstaticeWhyUs = () => {
  return (
    <section className="ac-why">
      <Container className="ac-why__container">
        <Row className="ac-why__row align-items-center">

          {/* Left — Content */}
          <Col lg={5} md={12} className="ac-why__content-col">
            <span className="ac-why__label">WHY ESTATICA</span>
            <h2 className="ac-why__heading">
              Trusted skin care, advanced technology.
            </h2>
            <p className="ac-why__desc">
              We combine board-certified dermatology expertise with modern laser
              systems and a calm, clinical environment built around patient comfort.
            </p>
          </Col>

          {/* Right — Feature Cards Grid */}
          <Col lg={7} md={12} className="ac-why__cards-col">
            <Row className="ac-why__cards-row">
              {features.map((feature) => (
                <Col sm={6} xs={12} key={feature.id} className="ac-why__card-col">
                  <div className="ac-why__card">
                    <div className="ac-why__icon-wrap">
                      {feature.icon}
                    </div>
                    <h6 className="ac-why__card-name">{feature.name}</h6>
                    <p className="ac-why__card-desc">{feature.desc}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default EstaticeWhyUs;